import { useState } from 'react';
import type { MediaFolderResponse } from '@/core/generated/api';
import { ActionMenu } from '@/shared/ui/ActionMenu/ActionMenu';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import type { ActionMenuItem } from '@/shared/ui/ActionMenu/types';
import classes from './MediaLibrary.module.scss';

interface MediaFolderCardsProps {
    folders: MediaFolderResponse[];
    onSelect: (id?: string) => void;
    actions?: (folder: MediaFolderResponse) => ActionMenuItem[];
}

/** Показывает подпапки порциями без создания карточек всего каталога */
export const MediaFolderCards = ({ folders, onSelect, actions }: MediaFolderCardsProps) => {
    const [limit, setLimit] = useState(50);

    return <>
        <div className={classes.folderGrid}>
            {folders.slice(0, limit)
                .map(folder => <div
                    className={classes.folderCard}
                    key={folder.id}
                >
                    <button
                        type="button"
                        onClick={() => onSelect(folder.id)}
                    >
                        <i
                            aria-hidden="true"
                            className="pi pi-folder"
                        />
                        <strong>{folder.name}</strong>
                    </button>
                    {actions &&
                        <ActionMenu
                            aria-label={`Действия папки ${folder.name}`}
                            model={actions(folder)}
                        />
                    }
                </div>)}
        </div>
        {folders.length > limit &&
            <ActionButton
                type="button"
                label={`Показать ещё папки (${folders.length - limit})`}
                color="secondary"
                outlined
                onClick={() => setLimit(previous => previous + 50)}
            />
        }
    </>;
};
